import { render, staticRenderFns } from "./GroupEditor.vue?vue&type=template&id=5a3c4e92"
import script from "./GroupEditor.vue?vue&type=script&lang=ts"
export * from "./GroupEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports